import React, { Component } from 'react';
import cn from 'classnames';
import { Popconfirm } from 'antd';
import PropTypes from 'prop-types';
import decodeHTMLEntities from '../../../../../helpers/decodeHTMLEntities';

class AnswerInput extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  render() {
    const {formatMessage} = this.context;
    const {deleteAnswer, isCurrent, isCorrect, index, correct_answer, meta: { touched, error }, answerLabel, input: {onChange, value}} =this.props;
    return (
      <div className="AnswerInput">
        <div className={cn({"answer-component" : 1, "right" : isCorrect})}>
          <div className="answer-label">{answerLabel}</div>
          <textarea
              {...this.props.input}
              id={"answer_text_"+index}
              onChange = {(e) => onChange(decodeHTMLEntities(e.target.value))}
              value = {decodeHTMLEntities(value)}
              className={cn("answer-content")}
          ></textarea>
          <React.Fragment>
            {
              value ? <Popconfirm
              title={formatMessage('msdAsnverDelete')}
              onConfirm={deleteAnswer}
              okText={formatMessage("msgYes")}
              cancelText={formatMessage("msgNo")}
            ><span className="cross-icon"></span></Popconfirm> : <span onClick={deleteAnswer} className="cross-icon"></span>
            }
              
              {correct_answer ? <Popconfirm
                title={formatMessage('msdAsnverConfirm')}
                onConfirm={isCurrent}
                okText={formatMessage("msgYes")}
                cancelText={formatMessage("msgNo")}
              >
                <span className="checked-icon"></span>
              </Popconfirm> : <span onClick={isCurrent} className="checked-icon"></span>}
          </React.Fragment>
        </div>
        {touched && ((error && <span className="error-message">{error}</span>))}
      </div>
    );
  }
}

export default AnswerInput;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/ModalFormQbm/components/components/AnswerInput.jsx